import * as angular from 'angular'

export class LogsFilterService {
  // tslint:disable-next-line:variable-name
  private _filter: {
    logtypes?: Array<string>
    logsubtype?: string
    result?: boolean
  } = {}

  get filter() {
    return this._filter
  }

  clearAll() {
    angular.copy({}, this.filter)
  }
}
